module.exports = __webpack_public_path__ + "static/media/eln.75784a30.jpg";